import * as React from 'react';

import { BaseComponent } from '../BaseComponent';
import { ViewSettingsStore } from '../../stores/ViewSettingsStore';
import { SidebarModule, Overlay } from '../../constants/Enums';
import { SidebarPosition, PersistentStore } from '../../stores/PersistentStore';
import { VisibilityStore } from '../../stores/VisibilityStore';
import { AppConfigurationStore } from '../../stores/AppConfigurationStore';

interface PageContainerState {
    hideBars: boolean;
    networkError: boolean;
    sidebarOrientation: SidebarPosition;
    sidebar: SidebarModule;
    fullscreen: boolean;
    overlay: Overlay;
}

export default class PageContainer extends BaseComponent<React.PropsWithChildren<{}>, PageContainerState> {
    public componentWillMount(): void {
        this.addStoreListener(ViewSettingsStore, this.onChange);
        this.addStoreListener(VisibilityStore, this.onChange);
        this.addStoreListener(PersistentStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element {
        const { touchDevice, inApp } = AppConfigurationStore.getState();
        return (
            <div
                className={[
                    'page-container',
                    this.state.hideBars && 'no-bars',
                    this.state.networkError && 'show-error',
                    ((touchDevice && !inApp)) && 'hide-ie-scroll',
                    touchDevice && 'core-hover-enabled wcf-hover-enabled',
                    inApp ? 'core-app-layout' : 'core-browser-layout',
                    this.state.sidebarOrientation === 'right' ? 'sidebar-on-right' : 'sidebar-on-left',
                    this.state.overlay !== Overlay.NONE ?
                        'page-container-white-bottom' :
                        this.state.sidebar === SidebarModule.PROJECTS && 'page-container-grey-bottom',
                ].join(' ')}
            >
                {this.props.children}
            </div>
        );
    }

    protected onChange = () => {
        const { hideBars, networkError, sidebar } = ViewSettingsStore.getState();
        const { fullscreen, overlay } = VisibilityStore.getState();
        this.setState({
            sidebarOrientation: PersistentStore.getState().sidebarPosition,
            hideBars,
            networkError,
            sidebar,
            fullscreen,
            overlay,
        });
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/mainContainer/PageContainer.tsx